/* Praella B2B Accelerator — interactivity
   Vanilla JS, no dependencies. Wires up:
   - Header background-on-scroll
   - FAQ accordion
   - Contact drawer (any <a href="#cta">)
*/
(function () {
  'use strict';

  // -------- Header scrolled state --------
  var header = document.querySelector('[data-ba-header]');
  if (header) {
    var hero = document.querySelector('.hero');
    function onScroll() {
      var threshold = hero ? hero.offsetHeight - (hero.offsetHeight * 0.8) : 200;
      if (window.scrollY > threshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // -------- FAQ accordion --------
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item, idx) {
    var btn = item.querySelector('.faq-q');
    if (!btn) return;
    if (idx === 0) item.classList.add('open');
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      faqItems.forEach(function (x) { x.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // -------- Contact drawer --------
  var drawer = document.querySelector('[data-ba-drawer]');
  var backdrop = document.querySelector('[data-ba-backdrop]');
  var closeBtn = document.querySelector('[data-ba-drawer-close]');
  var form = document.querySelector('[data-ba-form]');
  var success = document.querySelector('[data-ba-success]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    // reset success state
    if (success) success.style.display = 'none';
    if (form) form.style.display = '';
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#cta"]');
    if (!a) return;
    e.preventDefault();
    openDrawer();
  });
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // NOTE: replace with your form provider (HubSpot, Klaviyo, Shopify form, etc.)
      // For now we just show success.
      if (form) form.style.display = 'none';
      if (success) success.style.display = '';
    });
  }

  // -------- Mobile header drawer --------
  var mobileMenu = document.querySelector('[data-ba-mobile-menu]');
  var mobileToggle = document.querySelector('[data-ba-mobile-toggle]');
  var mobileClose = document.querySelector('[data-ba-mobile-close]');
  var mobileBackdrop = document.querySelector('[data-ba-mobile-backdrop]');

  function openMobileMenu() {
    if (!mobileMenu || !mobileToggle) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (mobileBackdrop) mobileBackdrop.classList.add('is-open');
    mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu || !mobileToggle) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (mobileBackdrop) mobileBackdrop.classList.remove('is-open');
    mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileBackdrop) mobileBackdrop.addEventListener('click', closeMobileMenu);

  var mobileLinks = document.querySelectorAll('.ba-mobile-link');
  mobileLinks.forEach(function (link) {
    link.addEventListener('click', closeMobileMenu);
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 980) closeMobileMenu();
  });
})();
